import { render, staticRenderFns } from "./IconChooser.vue?vue&type=template&id=1c37617b&scoped=true&"
import script from "./IconChooser.vue?vue&type=script&lang=js&"
export * from "./IconChooser.vue?vue&type=script&lang=js&"
import style0 from "./IconChooser.vue?vue&type=style&index=0&id=1c37617b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c37617b",
  null
  
)

export default component.exports